import Axios, { AxiosInstance } from "axios";
import { IHttpsAdapter, IInputRequest } from "./interface-https-adapter";
import { EncryptAdapter } from "../encrypt/encrypt-adapter";

class HttpsAdapter implements IHttpsAdapter {
  private static instance: HttpsAdapter;
  private readonly api: AxiosInstance;
  private publicKey = "";
  private publicKeyExpiresAt = 0; // timestamp em ms

  private constructor(baseUrl: string) {
    this.api = Axios.create({
      baseURL: baseUrl,
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 30000,
      withCredentials: true,
    });
  }

  static getInstance(baseUrl: string): HttpsAdapter {
    if (!HttpsAdapter.instance) {
      HttpsAdapter.instance = new HttpsAdapter(baseUrl);
    }
    return HttpsAdapter.instance;
  }

  private isPublicKeyExpired(): boolean {
    return !this.publicKey || Date.now() > this.publicKeyExpiresAt;
  }

  async request<T>(input: IInputRequest): Promise<T> {
    if (input.isEncrypt) {
      if (this.isPublicKeyExpired()) {
        const { data: dataKey } = await this.api.request({
          method: 'GET',
          url: '/api/crypto/public-key'
        });
        this.publicKey = dataKey;
        this.publicKeyExpiresAt = Date.now() + 5 * 60 * 1000; // 5 minutes cache
      }

      const {
        encryptedDataBase64,
        encryptedKeyBase64,
      } = await new EncryptAdapter(this.publicKey).encrypt(JSON.stringify(input.data));

      return this.api.request({
        method: input.method,
        url: input.path,
        headers: {
          ...input.headers,
          'X-Session-Encrypt': encryptedKeyBase64,
          'Content-Type': 'text/plain',
        },
        data: encryptedDataBase64,
      });
    }

    return this.api.request({
      headers: input.headers,
      method: input.method,
      url: input.path,
      ...(input.data ? { data: input.data } : {})
    });
  }
}

export default HttpsAdapter.getInstance(process.env.REACT_APP_CONECTOGO_URL_API as string);